import { render, staticRenderFns } from "./carbonEnergyDetail.vue?vue&type=template&id=7a967797&scoped=true&"
import script from "./carbonEnergyDetail.vue?vue&type=script&lang=js&"
export * from "./carbonEnergyDetail.vue?vue&type=script&lang=js&"
import style0 from "./carbonEnergyDetail.vue?vue&type=style&index=0&id=7a967797&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a967797",
  null
  
)

export default component.exports